export default __webpack_public_path__ + "static/media/left.3b295e70.png";